import React, { Component } from 'react';
import compose from 'lodash/flowRight';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';

import CoachSettingsRow from '../CoachSettingsRow';
import { COUNTRY_OPTIONS } from '../../constants';
import MHButton from '../MHButton';
import MHInput from '../MHInput';
import MHSelect from '../MHSelect';
import http from '../../services/Http';
import { textInputStyle } from '../../themes/input';

const styles = (theme) => ({
  ...textInputStyle(theme),
  countryMenu: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 12,
  },
  countryMenuText: {
    paddingLeft: 12,
  },
  flagIcon: {
    height: 24,
    width: 36,
  },
});

class LocationUpdate extends Component {
  state = {
    country: '',
    zipCode: '',
    city: '',
    state: '',
  };

  // TODO: Rewrite this to use hooks as a function component
  componentDidMount() {
    const state = this.getInitialValues();
    this.setState(state);
  }

  getInitialValues = () => {
    const { currentUser } = this.props;
    return {
      country: currentUser.country || '',
      zipCode: currentUser.zipCode || '',
      city: currentUser.city || '',
      state: currentUser.state || '',
    };
  };

  handleChange = (propertyToChange) => {
    return (event) => {
      // set the property
      this.setState({
        [propertyToChange]: event.target.value,
      });
    };
  };

  saveLocationDetails = async () => {
    const { currentUser } = this.props;
    const { country, zipCode, city, state } = this.state;

    try {
      await http.formDataPATCH(`accounts/${currentUser.id}/`, {
        country,
        zipCode,
        city,
        state,
      });
      this.props.fetchCurrentUser();
      this.props.enqueueSnackbar('Save success!', { variant: 'success' });
      this.props.closeDialog();
    } catch (error) {
      this.props.handleError(error);
    }
  };

  get locationDetailsDisabled() {
    const { currentUser } = this.props;
    const { country, zipCode, city, state } = this.state;

    const locationDetailsPristine =
      country === currentUser.country &&
      zipCode === currentUser.zipCode &&
      city === currentUser.city &&
      state === currentUser.state;
    return locationDetailsPristine;
  }

  render() {
    const { classes, closeDialog } = this.props;
    const { country, zipCode, city, state } = this.state;
    return (
      <Dialog open onClose={closeDialog} aria-labelledby="form-dialog-title" fullWidth>
        <DialogTitle id="form-dialog-title">Location</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle1" className={classes.cardTitle}>
            Let your clients know where you are located.
          </Typography>
          <CoachSettingsRow title="What country are you in?">
            <MHSelect
              value={country}
              onChange={this.handleChange('country')}
              className={classes.countryMenu}
            >
              <MenuItem value=""> -- </MenuItem>
              {COUNTRY_OPTIONS.map(({ text, value, icon }) => (
                <MenuItem key={value} value={value} className={classes.countryMenu}>
                  <div className={classes.countryMenu}>
                    <img src={icon} alt="" className={classes.flagIcon} />
                    <Typography variant="body1" className={classes.countryMenuText}>
                      {text}
                    </Typography>
                  </div>
                </MenuItem>
              ))}
            </MHSelect>
          </CoachSettingsRow>
          <CoachSettingsRow title="What is your zip/postal code">
            <MHInput value={zipCode} onChange={this.handleChange('zipCode')} />
          </CoachSettingsRow>
          <CoachSettingsRow title="City (optional)">
            <MHInput value={city} onChange={this.handleChange('city')} />
          </CoachSettingsRow>
          <CoachSettingsRow title="State (optional)">
            <MHInput value={state} onChange={this.handleChange('state')} />
          </CoachSettingsRow>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary">
            Cancel
          </Button>
          <MHButton
            children="Update"
            onClick={this.saveLocationDetails}
            disabled={this.locationDetailsDisabled}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

const mapState = (state) => ({
  currentUser: state.user.currentUser,
});

const mapDispatch = (store) => ({
  fetchCurrentUser: () => store.user.fetchCurrentUser(),
});

export default compose(
  withStyles(styles),
  connect(mapState, mapDispatch),
  withSnackbar,
)(LocationUpdate);
